module.exports = __webpack_public_path__ + "static/media/SanSalvador.122dcf1a.jpg";